import { render, staticRenderFns } from "./TemplateManage.vue?vue&type=template&id=5a6cece6&scoped=true&"
import script from "./TemplateManage.vue?vue&type=script&lang=js&"
export * from "./TemplateManage.vue?vue&type=script&lang=js&"
import style0 from "./TemplateManage.vue?vue&type=style&index=0&id=5a6cece6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6cece6",
  null
  
)

export default component.exports